export const financeiroEndpoint = {
    // Remessa
    remessa: {
        enviar: `/api/v1/financeiro/remessa/enviar`,
    },

    // Pagamentos
    pagamentos: {
        listar: `/api/v1/financeiro/pagamentos`,
        obter: (id) => `/api/v1/financeiro/pagamentos/${id}`,
        confirmar: (id) => `/api/v1/financeiro/pagamentos/${id}/confirmacao`,
        reabilitar: (id) => `/api/v1/financeiro/pagamentos/${id}/reabilitar`,
        cancelar: (id) => `/api/v1/financeiro/pagamentos/${id}/cancelar`,
        pausar: (id) => `/api/v1/financeiro/pagamentos/${id}/pausar`,
        atualizarTipoPagamento: (id) => `/api/v1/financeiro/pagamentos/${id}/tipo-pagamento`,
        atualizarDataVencimento: (id) => `/api/v1/financeiro/pagamentos/${id}/data-vencimento`,
        exportar: `/api/v1/financeiro/pagamentos/exportar`,
        listarNaoConciliados: `/api/v1/financeiro/pagamentos/nao-conciliados`,
        listarPorIdentificacao: `/api/v1/financeiro/pagamentos/por-identificacao`,

        // Comprovante
        obterComprovante: (pagamento_id) => `/api/v1/financeiro/pagamentos/${pagamento_id}/comprovante`,
        cadastrarComprovante: (id) => `/api/v1/financeiro/pagamentos/${id}/comprovante`,

        // Encargos e Erros
        obterEncargos: (id) => `/api/v1/financeiro/pagamentos/${id}/encargos`,
        obterErros: (id) => `/api/v1/financeiro/pagamentos/${id}/erros`,

        // Autorização
        autorizar: (id) => `/api/v1/financeiro/pagamentos/${id}/autorizacao`,
        autorizarLote: `/api/v1/financeiro/pagamentos/autorizacao/lote`,

        // Boleto
        atualizarBoleto: (id) => `/api/v1/financeiro/pagamentos/${id}/boleto`,

        // Sincronizar Dados do Pagamento
        sincronizarDados: (id) => `/api/v1/financeiro/pagamentos/${id}/beneficiario/sincronizacao`,
    },

    // Extrato
    extrato: {
        listarMovimentos: `/api/v1/financeiro/extrato`,
        atualizar: `/api/v1/financeiro/extrato/atualizar`,
        statusTarefa: (task_id) => `/api/v1/financeiro/extrato/tarefas/${task_id}`,
        importarOFX: `/api/v1/financeiro/extrato/importar-ofx`,
    },

    // Conciliação
    conciliacao: {
        conciliarManual: `/api/v1/financeiro/conciliacao`,
        listarEntidades: `/api/v1/financeiro/conciliacao/entidades`,
        listarCandidatos: `/api/v1/financeiro/conciliacao/candidatos`,
        listarTiposObjeto: `/api/v1/financeiro/conciliacao/tipos-objeto`,
        desfazer: (id) => `/api/v1/financeiro/conciliacao/${id}`,
        listarSugestoes: `/api/v1/financeiro/conciliacao/sugestoes`,
        listarDivergencias: `/api/v1/financeiro/conciliacao/divergencias`,
        grupoPagamento: (pagamentoId) => `/api/v1/financeiro/conciliacao/pagamentos/${pagamentoId}/grupo`,
    },

    // Boleto
    boleto: {
        processarCodigoBarras: `/api/v1/financeiro/boleto/codigos-barras`,
        processarLinhaDigitavel: `/api/v1/financeiro/boleto/linha-digitavel`,
    },

    // Exportações
    exportacoes: {
        planilhaContabilidade: `/api/v1/financeiro/planilha-contabilidade/exportar`,
        contasAPagar: `/api/v1/exportacao/contas-a-pagar`,
        contasAReceber: `/api/v1/exportacao/contas-a-receber`,
    },

    // Solicitações de Pagamentos Encargos
    solicitacoesPagamentosEncargos: {
        listar: `/api/v1/financeiro/encargos/solicitacoes-pagamentos`,
        criar: `/api/v1/financeiro/encargos/solicitacoes-pagamentos`,
        obter: (id) => `/api/v1/financeiro/encargos/solicitacoes-pagamentos/${id}`,
        baixarBoleto: (id) => `/api/v1/financeiro/encargos/solicitacoes-pagamentos/${id}/boleto`,
        criarDevolucao: (id) => `/api/v1/financeiro/solicitacoes/pagamentos/${id}/devolucao`,
        criarComplemento: (id) => `/api/v1/financeiro/solicitacoes/pagamentos/${id}/complemento`,
    },

    // Solicitações Financeiro
    solicitacoesFinanceiro: {
        listar: `/api/v1/financeiro/solicitacoes`,
        obter: (id) => `/api/v1/financeiro/solicitacoes/${id}`,
        avaliar: (id) => `/api/v1/financeiro/solicitacoes/${id}/avaliar`,
        obterComprovanteSolicitacaoFinanceira: (id) => `/api/v1/financeiro/solicitacoes/pagamentos/solicitacaofinanceiro/${id}/comprovante`,
    },

    // Pagamentos Encargos
    pagamentosEncargos: {
        listarPorProjeto: `/api/v1/financeiro/encargos/pagamentos/projetos`,
    },

    // Encargos
    encargos: {
        listar: `/api/v1/financeiro/encargos`,
        listarTipos: `/api/v1/financeiro/encargos/tipos-encargos`,
        calcularInssAutonomo: `/api/v1/financeiro/encargos/calcular-encargos-autonomo`,
    },

    labels: {
        listar: `/api/v1/financeiro/labels-pagamento`,
        cadastrar: `/api/v1/financeiro/labels-pagamento`,
        editar: (id) => `/api/v1/financeiro/labels-pagamento/${id}`,
        deletar: (id) => `/api/v1/financeiro/labels-pagamento/${id}`,
        associar: (id) => `/api/v1/financeiro/pagamentos/${id}/labels`,
        desassociar: (id) => `/api/v1/financeiro/pagamentos/${id}/labels`,
    },

    // Contas Bancárias
    contaBancaria: {
        listar: `/api/v1/financeiro/contabancaria`,
        obter: (id) => `/api/v1/financeiro/contabancaria/${id}`,
        criar: `/api/v1/financeiro/contabancaria`,
        atualizar: (id) => `/api/v1/financeiro/contabancaria/${id}`,
        inativar: (id) => `/api/v1/financeiro/contabancaria/${id}/inativar`,
        liberar: (id) => `/api/v1/financeiro/contabancaria/${id}/liberar`,
        ativar: (id) => `/api/v1/financeiro/contabancaria/${id}/ativar`,
    },

    // DDS Contabilidade
    ddsContabilidade: {
        exportar: '/api/v1/financeiro/dds/exportar'
    },
}
